import React from 'react';

// Shared Components
import { SUBSTORY_COLOR_LIST } from 'constants/MogamboConstants';
import styles from './TableName.scss';

export default function TableName({
  children = 'No Name',
  title,
  color = '#333',
  disabled,
}) {
  const firstLetter = children[0];
  const firstLetterIndex = Math.abs(parseInt(firstLetter, 36) - 9) || 16;
  const backgroundColor = SUBSTORY_COLOR_LIST[firstLetterIndex % 17].primary;
  const disabledClassName = disabled ? styles.disabled : '';
  return (
    <div className={`${styles.tableName} ${disabledClassName}`}>
      <div style={{ backgroundColor }} className={styles.tableNameIcon}>
        {title ? title[0] : children[0]}
      </div>
      <div className={styles.tableNameText}>{children}</div>
    </div>
  );
}
